import React from 'react'
import { Row, Col, Badge, Image } from 'antd'
import { Data, ProductOptions as ProductOptionsTypes, RequestData } from 'Store/product/types'
import { TableListPage } from 'Components/common/Table'
import styled from 'styled-components'
import { MyTheme } from 'Components/common/Theme'
import { StatusTag } from 'Components/utilities'
import { appConfig } from 'config'
import { FormItem } from 'Components/form'
import { numberWithComma, roundNumber } from 'helpers/format'
import { ImageFallback } from 'helpers/constanst'

type Props = {
  formData?: RequestData
}

const ProductOptions: React.FunctionComponent<Props> = props => {
  const { formData } = props

  const renderImage = (img: string) => (
    <ThumbImage src={appConfig.assetCdnEndpoint + img} fallback={ImageFallback} />
  )

  const renderStatus = (publish: boolean) => (
    <StatusTag isPass={publish === true} text={publish ? 'เปิดใช้งาน' : 'ปิดใช้งาน'} />
  )

  const renderCount = (color: string, title: string, count: number, unit: string = 'ซม.') => (
    <DetailText key={title}>
      <Row justify="space-between" align="middle">
        <Col>
          <Badge color={color} />
          {title}
        </Col>
        <Col>
          {' '}
          {roundNumber(count)} {unit}
        </Col>
      </Row>
    </DetailText>
  )

  const renderDetail = (weight: number, record: ProductOptionsTypes) => {
    return (
      <>
        {record.weight > 0 && renderCount('grey', 'น้ำหนัก', weight, 'กก.')}
        {record.width > 0 ? renderCount('grey', 'ความกว้าง', record.width) : ''}
        {record.height > 0 ? renderCount('grey', 'ความสูง', record.height) : ''}
        {record.depth > 0 ? renderCount('grey', 'ความลึก', record.depth) : ''}
        {record.length > 0 ? renderCount('grey', 'ความยาว', record.length) : ''}
        {record.area > 0 ? renderCount('grey', 'พื้นที่', record.area) : ''}
      </>
    )
  }

  const columns = [
    {
      title: 'รูปภาพ',
      dataIndex: 'photo',
      key: 'photo',
      render: renderImage,
      width: '120px',
    },
    {
      title: 'ชื่อสินค้า',
      dataIndex: 'title',
      key: 'title',
    },
    {
      title: 'ราคา',
      dataIndex: 'price',
      key: 'price',
      render: (price: number) => numberWithComma(price, true),
    },
    {
      title: 'สต๊อก',
      dataIndex: 'quantity',
      key: 'quantity',
      render: (quantity: number) => numberWithComma(quantity),
    },
    {
      title: 'รายละเอียด',
      dataIndex: 'weight',
      key: 'weight',
      render: renderDetail,
      width: '150px',
    },
    {
      title: 'สถานะ',
      dataIndex: 'publish',
      key: 'publish',
      render: renderStatus,
    },
  ]

  return (
    <Row>
      <Col md={24} xs={24}>
        <FormItem label="" error={`กรุณาระบุ ตัวเลือกสินค้าอย่างน้อย 1 ตัวเลือก`}>
          <Row justify="space-between" align="middle">
            <Col>
              <Title>ตัวเลือกสินค้า</Title>
            </Col>
          </Row>
          <Row>
            <Col md={24} xs={24}>
              <TableListPage
                columns={columns}
                datas={formData?.product_options || []}
                scrollX={800}
                size={'small'}
              />
            </Col>
          </Row>
        </FormItem>
      </Col>
    </Row>
  )
}

const DetailText = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.black};
  font-weight: 100;
  line-height: 1;
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.regular};
  padding-right: 10px;
`

const ThumbImage = styled(Image)`
  border-radius: 5px;
  width: 80px;
  height: 80px;
  object-fit: cover;
`

const Title = styled.div`
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.bold};
  font-weight: 500;
`

export default ProductOptions
